import { WorkflowTaskPermissions, WriteWorkflowTaskModel } from "../../api/clients/workflowTasks/DTOs"
import WorkflowTasksClient from "../../api/clients/workflowTasks/WorkflowTasksClient"
import { WorkflowEvent, WorkflowTaskEventAction, WorkflowTaskWorkflowEventData } from "../../api/clients/workflows/DTOs"
import { InteractiveWorkflowTaskState, isInteractiveWorkflowTask } from "../../modules/Workflows/InteractiveWorkflowTasks/IInteractiveWorkflowTask"

export async function getActiveInteractiveTasks(workflowEvents: WorkflowEvent[]) {
	const workflowTasksClient = new WorkflowTasksClient()

	const workflowTaskEvents = workflowEvents
		.filter((v) => v.eventType === 'WorkflowTask')
		.map((v) => v.eventData as WorkflowTaskWorkflowEventData)


	const workflowTasks: WriteWorkflowTaskModel<InteractiveWorkflowTaskState>[] =
		[]

	
	// we want to get workflow tasks that are still active
	for (const event of workflowTaskEvents.filter(
		(v) => v.action === WorkflowTaskEventAction.Created,
	)) {
		if (
			!workflowTaskEvents.some(
				(v) =>
					v.workflowTaskId === event.workflowTaskId &&
					v.action !== WorkflowTaskEventAction.Created,
			)
		) {
			const { data: workflowTask } =
				await workflowTasksClient.getWorkflowTask(
					event.workflowTaskId,
					WorkflowTaskPermissions.Write,
				)

			if (isInteractiveWorkflowTask(workflowTask))
				workflowTasks.push(
					workflowTask as WriteWorkflowTaskModel<InteractiveWorkflowTaskState>,
				)
		}
	}

	return workflowTasks
}
